import { getInvestorApiBase } from "../../utils/investorApiBase";

/**
 * Turn API file paths into absolute URLs using REACT_APP_ASSET_OWNER_Url.
 * Paths already under `uploads/` are joined to the base; everything else is prefixed with `/uploads/`
 * (e.g. `assets/.../mainImage_123` → `{base}/uploads/assets/.../mainImage_123`).
 */
export function resolveInvestorUploadUrl(fileUrl) {
  if (!fileUrl) return "";
  const s = String(fileUrl).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const path = s.replace(/^\//, "");
  const API_BASE = getInvestorApiBase();
  if (!API_BASE) return path;
  if (path.startsWith("uploads/")) {
    return `${API_BASE}/${path}`;
  }
  return `${API_BASE}/uploads/${path}`;
}

/**
 * Normalizes one row from GET /api/investor/my-investments for UI.
 * @param {object} row - API item: { asset, statusType, tokensOwned, ... }
 */
export function mapMyInvestmentRow(row) {
  if (!row || typeof row !== "object") return null;
  const asset = row.asset && typeof row.asset === "object" ? row.asset : {};
  const id = asset._id;
  if (!id) return null;

  const categoryName =
    asset.assetCategory?.name || asset.category || asset.categoryName || "";

  return {
    assetId: id,
    assetName: asset.assetName,
    description: asset.description,
    location: asset.location,
    category: asset.category,
    categoryName,
    totalSupply: Number(asset.totalSupply ?? asset.tokenEconomics?.totalSupply) || 0,
    propertyType: asset.propertyType,
    mainImageUrl: resolveInvestorUploadUrl(asset.mainImage),
    expectedROI: asset.expectedROI,
    yield: asset.yield,
    assetStatus: asset.status,
    pricePerToken: asset.pricePerToken,
    totalAssetValue: asset.totalAssetValue,
    statusType: row.statusType,
    totalReturn: row.totalReturn,
    currentValue: row.currentValue,
    myStake: row.myStake,
    tokensOwned: row.tokensOwned,
    nextPayoutDate: row.nextPayoutDate,
    estimatedPayoutAmount: row.estimatedPayoutAmount,
    investmentCount: row.investmentCount,
    totalTokenAmount: row.totalTokenAmount,
    totalAmount: row.totalAmount,
    investments: Array.isArray(row.investments) ? row.investments : [],
  };
}
